import { useEffect, useState } from 'react'

import { useQueryAuditLog } from '../../models/useQueryAuditLog'

export const useAuditLogListPresenter = ({
  contentTypeId,
  objectId,
}: {
  contentTypeId: number
  // Omitted → module-wide log for the content type (BHV-030)
  objectId?: string
}) => {
  const { auditLog, isError, isLoading, isPreviousData } = useQueryAuditLog({
    contentTypeId,
    objectId,
  })

  const showAuditLog = auditLog && auditLog.length > 0
  // Entries kept from an earlier success still render after a failed
  // refetch; the error replaces only the no-history empty state.
  const showLoadError = isError && !showAuditLog

  // Latched per log: the presenter remounts for each log. The shared
  // 'audit-log' page count can still belong to an earlier log until this
  // one shows entries of its own.
  const [hasShownEntries, setHasShownEntries] = useState(false)

  useEffect(() => {
    if (showAuditLog) {
      setHasShownEntries(true)
    }
  }, [showAuditLog])

  return {
    data: { auditLog },
    state: {
      showLoader: isLoading,
      // A page change keeps the previous page's entries under an overlay so
      // the pager stays mounted and keeps focus. Same-page refetches (reopen,
      // invalidation) show no overlay.
      showPageChangeLoader: isPreviousData,
      showAuditLog,
      showLoadError,
      // An empty log, or one that has never loaded, has nothing to page. A
      // failed page change keeps the pager so the user can page back.
      showPager: showAuditLog || (showLoadError && hasShownEntries),
    },
  }
}
